import React from 'react';
import { useTypedDispatch, useTypedSelector } from '@/store';
import { Drawer } from 'antd';
import { MenuUnfoldOutlined } from '@ant-design/icons';

import MainSidebar from '@/layouts/Main/Sidebar';
import SettingsSidebar from '@/layouts/Settings/Sidebar';
import Stats from '@/layouts/Main/Header/Stats';
import UserAvatar from '@/components/UserAvatar';

import pomodizerLogo from '@/assets/img/pomodizer-logo.png'

import { setIsDrawerOpened } from '@/store/core';

import CloseIcon from '@/assets/icons/close.svg?react';
import { useLocation } from 'react-router';

const MobileHeader = () => {
  const location = useLocation();
  const dispatch = useTypedDispatch();

  const isDrawerOpened = useTypedSelector(state => state.core.isDrawerOpened);

  const onSetisDrawerOpened = (payload: boolean) => dispatch(setIsDrawerOpened(payload));

  return (
    <div className="mobile-header">
      <MenuUnfoldOutlined className="mobile-header__unfold" onClick={() => onSetisDrawerOpened(true)} />

      <Stats onlyPlanning />
      <div className="mobile-header__avatar">
        <UserAvatar />
      </div>

      <Drawer
        forceRender
        className="drawer"
        title={
          <img
            className="mobile-header__logo"
            src={pomodizerLogo}
            alt="logo"
          />
        }
        placement="left"
        width="80%"
        closable={false}
        closeIcon={<CloseIcon />}
        visible={isDrawerOpened}
        onClose={() => onSetisDrawerOpened(false)}
      >
        {location.pathname.includes('settings') ? (
          <SettingsSidebar withAdditionalLinks />
        ) : (
          <MainSidebar />
        )}
      </Drawer>
    </div>
  );
};

export default MobileHeader;
